import { LogIn } from "lucide-react";
import { BRAND } from "@/lib/data";

export default function AdminLogin() {
  const startLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="admin-login" className="min-h-screen flex items-center justify-center bg-ink px-6">
      <div className="bg-cream max-w-md w-full p-10 text-center border border-gold/30">
        <img src={BRAND.logo} alt="La Contadina" className="h-20 w-20 rounded-full object-cover ring-1 ring-gold/40 mx-auto mb-6" />
        <h1 className="font-serif text-4xl text-wine mb-2">Admin-Bereich</h1>
        <p className="text-ink-soft font-light mb-8">Melden Sie sich an, um Texte und Bilder Ihrer Website zu bearbeiten.</p>
        <button
          data-testid="google-login-btn"
          onClick={startLogin}
          className="btn-pop w-full bg-wine text-cream py-4 uppercase text-xs tracking-[0.25em] flex items-center justify-center gap-3 hover:bg-wine-dark"
        >
          <LogIn size={18} /> Mit Google anmelden
        </button>
        <p className="text-xs text-ink-muted mt-6">Zugang nur für freigegebene Admin-Konten.</p>
      </div>
    </div>
  );
}
